import Vue from 'vue'
import Router from 'vue-router'
import Splash from '@/view/splash'
import Home from '@/view/tab/navigation/home'
import pserson from '@/view/user/pserson'
import course from '@/view/tab/navigation/good_course';
import video from '@/view/video/video';
import news from '@/view/news/news';
import detail from '@/view/news/detail';
import activity from '@/view/activity/activity';
import activitydes from '@/view/activity/activitydes';
import search from '@/view/search/search';
import login from '@/view/autoLogin/login';
import err from '@/view/notfound/err';
import list from '@/view/tab/navigation/list';
import index from '@/view/index'
Vue.use(Router)

export default new Router({

    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    },
    routes: [{
            path: '/kid/all',
            name: 'splash',
            component: Splash,
            meta: {
                keepAlive: true,
                title: '少儿多媒体图书馆'
            },
            children: []
        },
        {
            path: "/person",
            name: 'pserson',
            component: pserson,
            meta: {
                keepAlive: true,
                title: '个人中心'
            },
        }, {
            path: "/",
            name: 'home',
            component: Home,
            meta: {
                keepAlive: true,
                title: '少儿多媒体图书馆',
            }
        }, {
            path: "/kid/course",
            name: 'course',
            component: course,
            meta: {
                keepAlive: true,
                title: '少儿多媒体图书馆'
            }
        },{
            path: "/kid/list",
            name: 'list',
            component: list,
            meta: {
                title: '少儿多媒体图书馆'
            }
        },  {
            path: "/kid/video/:Id/:cateId/:videoId",
            name: 'video',
            component: video,
            meta: {
                title: '少儿多媒体图书馆'
            }
        }, 
        {
            path: "/kid/search",
            name: 'search',
            component: search,
            meta: {
                title: '搜索结果'
            }
        },
        {
            path: "/AutoLogin/login",
            name: 'login',
            component: login,
            meta: {
                title: '登录'
            }
        },
        {
            path: "/index/:isfirst/:states", //states  auto = 免登錄 login登錄 reigist 注冊",
            name: 'index',
            component: index,
            meta: {
                title: '少儿多媒体图书馆'
            }
        },
        {
            path: "*",
            name: 'err',
            component: err,
            meta: {
                title: '页面丢失'
            }
        }
    ]
})

// 在一个路由下再次push这个路由前台会报错 这个方法是为了屏蔽掉这个错误
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

/*
废弃路由
import root from '@/view/tab/root.vue';
import picture from '@/view/tab/navigation/picture_books';
import guide from '@/view/tab/navigation/read_guide';
import ebook from '@/view/tab/navigation/ebooks';
import microclass from '@/view/tab/navigation/micro_class';
import playground from '@/view/tab/navigation/playground';
import teacher from '@/view/tab/navigation/teacher';
import parent from '@/view/tab/navigation/parent_course';
import three from '@/view/tab/navigation/to_three';
import six from '@/view/tab/navigation/to_six';
import fifteen from '@/view/tab/navigation/to_fiveteen';
{
            path: "/kid/microclass",
            name: 'microclass',
            component: microclass,
            meta: {
                keepAlive: true,
                title: '少儿多媒体图书馆'
            }
        }, {
            path: "/kid/playground",
            component: playground,
            name: 'playground',
            meta: {
                keepAlive: true,
                title: '少儿多媒体图书馆'
            }
        }, {
            path: "/kid/teacher",
            name: 'teacher',
            component: teacher,
            meta: {
                keepAlive: true,
                title: '少儿多媒体图书馆'
            }
        }, {
            path: "/kid/parent",
            name: 'parent',
            component: parent,
            meta: {
                keepAlive: true,
                title: '少儿多媒体图书馆'
            }
        }, {
            path: "/kid/three",
            name: 'three',
            component: three,
            meta: {
                keepAlive: true,
                title: '少儿多媒体图书馆'
            }
        }, {
            path: "/kid/six",
            name: 'six',
            component: six,
            meta: {
                keepAlive: true,
                title: '少儿多媒体图书馆'
            }
        }, {
            path: "/kid/fifteen",
            name: 'fifteen',
            component: fifteen,
            meta: {
                keepAlive: true,
                title: '少儿多媒体图书馆'
            }
        },
         {
            path: "/kid/picture",
            name: 'picture',
            component: picture,
            meta: {
                keepAlive: true,
                title: '少儿多媒体图书馆'
            }
        }, {
            path: "/kid/guide",
            name: 'guide',
            component: guide,
            meta: {
                keepAlive: true,
                title: '少儿多媒体图书馆'
            }
        }, {
            path: "/kid/ebook",
            name: 'ebook',
            component: ebook,
            meta: {
                keepAlive: true,
                title: '少儿多媒体图书馆'
            }
        },
        {
            path: "/kid/news",
            name: 'news',
            component: news,
            meta: {
                keepAlive: true,
                title: '少儿多媒体图书馆'
            }
        }, {
            path: "/kid/news/:Id",
            name: 'detail',
            component: detail,
            meta: {
                title: '少儿多媒体图书馆'
            }
        }, {
            path: "/kid/activity",
            name: 'activity',
            component: activity,
            meta: {
                keepAlive: true,
                title: '活动列表'
            }
        },
        {
            path: "/kid/activity/:id",
            name: 'activitydes',
            component: activitydes,
            meta: {
                title: '活动详情'
            }
        },
*/ 


// WEBPACK FOOTER //
// ./src/router/index.js